// const CustomStyle = {
//     multiselect: {
//         '& .MuiInputBase-root': {
//             fontSize: '13px',
//             boxShadow: 'none',
//             borderWidth: '1px',
//         },
//         '& .MuiOutlinedInput-root': {
//             '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                 borderWidth: '1px',
//                 borderColor: '#afc0f7',
//             },
//             '&:hover .MuiOutlinedInput-notchedOutline': {
//                 borderColor: '#ced4da',
//             },
//             '.MuiOutlinedInput-notchedOutline': {
//                 borderColor: '#ced4da',
//             },
//         },
//         '& .MuiOutlinedInput-notchedOutline': {
//             borderWidth: '1px',
//             borderColor: '#afc0f7',
//         },
//         '& .MuiFormHelperText-root': {
//             fontSize: '12px',
//         },
//     },
//     singleselect: {
//         '& .MuiInputBase-root': {
//             fontSize: '13px',
//             boxShadow: 'none',
//             borderWidth: '1px',
//         },
//         '& .MuiOutlinedInput-root': {
//             '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                 borderWidth: '1px',
//                 borderColor: '#afc0f7',
//             },
//             '&:hover .MuiOutlinedInput-notchedOutline': {
//                 borderColor: '#ced4da',
//             },
//             '.MuiOutlinedInput-notchedOutline': {
//                 borderColor: '#ced4da',
//             },
//         },
//         '& .MuiOutlinedInput-notchedOutline': {
//             borderWidth: '1px',
//             borderColor: '#afc0f7',
//         },
//         '& .MuiFormHelperText-root': {
//             fontSize: '12px',
//         },
//     },
// };

import { MecordColors } from "./Color";

// export default CustomStyle;

const CustomStyle = {
  multiselect: {
    "& .MuiInputBase-root": {
      fontSize: "13px",
      boxShadow: "none",
      borderWidth: "1px",
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderWidth: "1px",
        borderColor: "#afc0f7",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#ced4da",
      },
      ".MuiOutlinedInput-notchedOutline": {
        borderColor: "#ced4da",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderWidth: "1px",
      borderColor: "#afc0f7",
    },
    "& .MuiFormHelperText-root": {
      fontSize: "12px",
    },
  },
  singleselect: {
    "& .MuiInputBase-root": {
      fontSize: "13px",
      boxShadow: "none",
      borderWidth: "1px",
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderWidth: "1px",
        borderColor: "#afc0f7",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#ced4da",
      },
      ".MuiOutlinedInput-notchedOutline": {
        borderColor: "#ced4da",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderWidth: "1px",
      borderColor: "#afc0f7",
    },
    "& .MuiFormHelperText-root": {
      fontSize: "12px",
    },
  },
};

export default CustomStyle;

// Common disabled input background color
export const DISABLED_INPUT_BG = "#e9ecef";

export const DETAILS_BG =
  "shadow-sm bg-light p-4 rounded-2 border border-secondary";

// Common function to get disabled input styles for MUI TextField/Autocomplete
export const getDisabledInputStyles = (disabled: boolean) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: disabled ? DISABLED_INPUT_BG : "#fff",
    "&.Mui-disabled": {
      backgroundColor: DISABLED_INPUT_BG,
    },
    "& fieldset": {
      border: "1px solid #ced4da",
    },
    "&:hover fieldset": {
      border: "1px solid #ced4da",
    },
    "&.Mui-focused fieldset": {
      border: "1px solid #ced4da",
    },
  },
});

// Common Autocomplete dropdown styles
//   ListboxProps: {
export const autocompleteDropdownStyles = {
  //     sx: {
  //       fontFamily: "Poppins, sans-serif",
  //       fontSize: "13px",
  //       "& .css-1wpdqyc-MuiFormControl-root-MuiTextField-root": {
  //         borderRadius: "3px",
  //       },
  //       "& .MuiAutocomplete-option": {
  //         fontFamily: "Poppins, sans-serif",
  //         fontSize: "13px",
  //       },
  //     },
  //   },

  ListboxProps: {
    sx: {
      fontFamily: "Poppins, sans-serif",
      fontSize: "13px",

       "&:not(:hover) .MuiAutocomplete-option": {
          backgroundColor: "transparent",
          boxShadow: "none",
          color: MecordColors.NormalText,
        },

      // Style options with custom colors while preserving keyboard navigation
      "& .MuiAutocomplete-option": {
        fontFamily: "Poppins, sans-serif",
        fontSize: "13px",
        cursor: "pointer",
        padding: "0.5rem 1rem",
        transition: "all 0.2s ease",
        // Default state
        color: MecordColors.NormalText,
        backgroundColor: "transparent",
        // Selected state
        "&[aria-selected='true']": {
          backgroundColor: MecordColors.ActiveBackground,
          color: MecordColors.ActiveText,
        },
        // Hover state (mouse only, not keyboard)
        "&:hover:not(.Mui-focused)": {
          backgroundColor: MecordColors.Hover.backgroundColor,
          boxShadow: MecordColors.Hover.boxShadow,
          color: MecordColors.ActiveText,
        },
        "&.Mui-focused.Mui-focusVisible": {
          backgroundColor: MecordColors.ActiveBackground,
          boxShadow: MecordColors.Hover.boxShadow,
          color: MecordColors.ActiveText,
        },
        "&[aria-selected='true'].Mui-focused.Mui-focusVisible": {
          backgroundColor: MecordColors.ActiveBackground,
          boxShadow: MecordColors.Hover.boxShadow,
          color: MecordColors.ActiveText,
        },

        // Keyboard focus state - only show when actively hovering or keyboard navigating
        // This prevents sticky highlight when mouse leaves
        "&.Mui-focused:hover": {
          backgroundColor: MecordColors.ActiveBackground,
          color: MecordColors.ActiveText,
        },
        // Selected + focused state
        "&[aria-selected='true'].Mui-focused": {
          backgroundColor: MecordColors.ActiveBackground,
          color: MecordColors.ActiveText,
        },
        // Override: When Mui-focused but NOT hovering, use transparent background
        // This fixes the "sticky highlight" issue
        // "&.Mui-focused:not(:hover)": {
        //   backgroundColor: "transparent",
        //   color: MecordColors.NormalText,
        // },
        // // But keep selected items highlighted even when focused but not hovering
        
      },
    },
  },

  // renderOption: (props: any, option: any, getOptionLabel?: (option: any) => string) => {
  //     const { key, ...rest } = props;
  //     return (
  //         <li
  //             key={key}
  //             {...rest}
  //             style={{
  //                 fontFamily: 'Poppins, sans-serif',
  //                 fontSize: '13px',
  //             }}
  //         >
  //             {getOptionLabel ? getOptionLabel(option) : option?.toString() || ''}
  //         </li>
  //     );
  // },

  renderOption: (
    props: any,
    option: any,
    getOptionLabel: (option: any) => string,
  ) => {
    const { key, style, ...rest } = props;

    // Merge styles: preserve MUI's styles and add only non-conflicting custom styles
    // Background and color are handled by CSS in ListboxProps to preserve keyboard navigation
    const mergedStyle = {
      ...(style || {}), // Preserve MUI's inline styles
      // Note: fontFamily, fontSize, padding, cursor, transition are handled by CSS
      // We don't set background/color here to avoid overriding MUI's focus states
    };

    // Preserve all original props including event handlers for keyboard navigation
    return (
      <li key={key} {...rest} style={mergedStyle}>
        {getOptionLabel ? getOptionLabel(option) : option?.toString() || ""}
      </li>
    );
  },

  // Common input field styles for selected value
  inputSx: {
    fontFamily: "Poppins, sans-serif",
    "& input": {
      fontFamily: "Poppins, sans-serif",
      fontSize: "13px",
    },
    "& .MuiInputBase-input::placeholder": {
      fontFamily: "Poppins, sans-serif",
      fontSize: "13px",
    },
  },
};

// Common table styles with consistent color scheme
export const tableStyles = {
  // Primary color for table elements
  primaryColor: MecordColors?.ThemeBGColor,

  // Secondary color for table elements
  secondaryColor: "#7e7357",

  // Table header styles
  header: {
    backgroundColor: MecordColors?.ThemeBGColor,
    color: "#fff",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    fontWeight: 600,
    borderBottom: "2px solid #2d6a66",
    padding: "12px 8px",
    textAlign: "center" as const,
  },

  // Alternative table header styles (for future use)
  headerAlt: {
    backgroundColor: MecordColors?.ThemeBGColor,
    color: "#fff",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    fontWeight: 600,
    // borderBottom: '2px solid #6b6249',
    borderBottom: `2px solid ${MecordColors?.ThemeBGColor}`,
    padding: "12px 8px",
    textAlign: "center" as const,
  },

  // Table cell styles
  cell: {
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    padding: "8px",
    verticalAlign: "middle" as const,
    borderBottom: "1px solid #e9ecef",
  },

  // Action column styles
  actionCell: {
    position: "sticky" as const,
    right: 0,
    backgroundColor: "#fff",
    zIndex: 10,
    textAlign: "center" as const,
    verticalAlign: "middle" as const,
    padding: "8px",
    minWidth: "100px",
    width: "100px",
  },

  // Action column when editing
  actionCellEditing: {
    position: "sticky" as const,
    right: 0,
    backgroundColor: "#f8f9fa",
    zIndex: 10,
    textAlign: "center" as const,
    verticalAlign: "middle" as const,
    padding: "8px",
    minWidth: "100px",
    width: "100px",
  },

  // Action column header styles
  actionHeader: {
    position: "sticky" as const,
    right: 0,
    zIndex: 11,
  },

  // Action button container
  actionButtonContainer: {
    display: "flex",
    gap: "6px",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },

  // Table row hover effect
  rowHover: {
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "#f8f9fa",
    },
  },

  // Editing row background
  rowEditing: {
    backgroundColor: "#f8f9fa",
    transition: "background-color 0.2s ease",
  },
};

// Common FilterPopover styles
export const filterPopoverStyles = {
  // Primary color for filter popover
  primaryColor: MecordColors?.ThemeBGColor,

  // Common font styles
  fontFamily: "Poppins, sans-serif",
  fontSize: "13px",

  // Popover container styles
  container: {
    fontFamily: "Poppins, sans-serif",
  },

  // TextField styles for search input
  textField: {
    fontFamily: "Poppins, sans-serif",
    "& input": {
      fontFamily: "Poppins, sans-serif",
      fontSize: "13px",
    },
    "& .MuiInputLabel-root": {
      fontFamily: "Poppins, sans-serif",
      fontSize: "13px",
      "&.Mui-focused": {
        color: `${MecordColors?.ThemeBGColor} !important`,
      },
    },
    "& .MuiFormHelperText-root": {
      fontFamily: "Poppins, sans-serif",
      fontSize: "13px",
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: MecordColors?.ThemeBGColor,
      },
    },
    // Date picker calendar styles
    '& input[type="date"]::-webkit-calendar-picker-indicator': {
      cursor: "pointer",
    },
    '& input[type="date"]': {
      colorScheme: "light",
    },
  },

  // Autocomplete TextField styles
  autocompleteTextField: {
    fontFamily: "Poppins, sans-serif",
    "& input": {
      fontFamily: "Poppins, sans-serif",
      fontSize: "13px",
    },
    "& .MuiInputLabel-root": {
      fontFamily: "Poppins, sans-serif",
      fontSize: "13px",
      "&.Mui-focused": {
        color: `${MecordColors?.ThemeBGColor} !important`,
      },
    },
    "& .MuiFormHelperText-root": {
      fontFamily: "Poppins, sans-serif",
      fontSize: "13px",
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: MecordColors?.ThemeBGColor,
      },
    },
  },

  // Button styles
  button: {
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
  },

  // Cancel button styles
  cancelButton: {
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    borderColor: "#ced4da",
    color: "#212529",
    "&:hover": {
      borderColor: "#adb5bd",
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
    "&.Mui-focused": {
      borderColor: "#ced4da !important",
      boxShadow: "0 0 0 0.2rem rgba(206, 212, 218, 0.5) !important",
    },
    "&:focus-visible": {
      outline: "none",
      borderColor: "#ced4da !important",
      boxShadow: "0 0 0 0.2rem rgba(206, 212, 218, 0.5) !important",
    },
  },

  // Apply button styles (primary color)
  applyButton: {
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    backgroundColor: MecordColors?.PrimaryButtonBGColor,
    "&:hover": {
      backgroundColor: MecordColors?.PrimaryButtonHoverBGColor,
    },
  },

  // React DatePicker styles
  datePicker: {
    width: "100%",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
  },
};

// MUI DatePicker calendar styles with primary color
export const muiDatePickerStyles = {
  // Calendar picker styles
  calendar: {
    "& .MuiPickersCalendarHeader-root": {
      backgroundColor: MecordColors?.PrimaryButtonBGColor,
      color: "#fff",
    },
    "& .MuiPickersCalendarHeader-label": {
      color: "#fff",
      fontFamily: "Poppins, sans-serif",
      fontSize: "13px",
    },
    "& .MuiPickersArrowSwitcher-button": {
      color: "#fff",
    },
    "& .MuiDayCalendar-weekContainer": {
      "& .MuiPickersDay-root": {
        fontFamily: "Poppins, sans-serif",
        fontSize: "13px",
        "&.Mui-selected": {
          backgroundColor: MecordColors?.PrimaryButtonBGColor,
          color: "#fff",
          "&:hover": {
            backgroundColor: MecordColors?.PrimaryButtonHoverBGColor,
          },
        },
        "&:hover": {
          backgroundColor: "rgba(61, 132, 128, 0.1)",
        },
      },
    },
  },
};

// React DatePicker CSS styles for primary color
export const datePickerStyles = `
  .react-datepicker {
    font-family: 'Poppins, sans-serif' !important;
    font-size: 13px !important;
  }
  
  .react-datepicker__header {
    background-color: ${MecordColors?.ThemeBGColor} !important;
    border-bottom: none !important;
  }
  
  .react-datepicker__current-month,
  .react-datepicker__day-name {
    color: #fff !important;
    font-family: 'Poppins, sans-serif' !important;
    font-size: 13px !important;
  }
  
  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
    background-color: ${MecordColors?.ThemeBGColor} !important;
    color: #fff !important;
  }
  
  .react-datepicker__day--selected:hover,
  .react-datepicker__day--in-selecting-range:hover,
  .react-datepicker__day--in-range:hover {
    background-color: #2d6a66 !important;
  }
  
  .react-datepicker__day:hover {
    background-color: rgba(61, 132, 128, 0.1) !important;
  }
  
  .react-datepicker__day--keyboard-selected {
    background-color: rgba(61, 132, 128, 0.2) !important;
    color: #212529 !important;
  }
  
  .react-datepicker__day--keyboard-selected:hover {
    background-color:${MecordColors?.ThemeBGColor} !important;
    color: #fff !important;
  }
  
  .react-datepicker__triangle {
    border-bottom-color:${MecordColors?.ThemeBGColor} !important;
  }
  
  .react-datepicker__input-container input {
    font-family: 'Poppins, sans-serif' !important;
    font-size: 13px !important;
    width: 100% !important;
    padding: 8px 12px !important;
    border: 1px solid #ced4da !important;
    border-radius: 4px !important;
  }
  
  .react-datepicker__input-container input:focus {
    outline: none !important;
    border-color: ${MecordColors?.ThemeBGColor} !important;
    box-shadow: 0 0 0 0.2rem rgba(61, 132, 128, 0.25) !important;
  }
  
  /* Ensure datepicker calendar appears above MUI Popover */
  .react-datepicker-popper {
    z-index: 1400 !important;
  }
  
  .react-datepicker {
    z-index: 1400 !important;
  }
`;
